import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { InfluencerTabField, KeywordField, CountriesField, CampaignCategoryField } from '../../shared';
import { BasicFilterDefaultProps } from '../../schemaTypes';

export const BasicFilter = ({ onSubmit, isEngagementPage }: BasicFilterDefaultProps) => {
  const { t } = useTranslation();

  return (
    <Form.Fields>
      <InfluencerTabField isEngagementPage={isEngagementPage} onSubmit={onSubmit} />
      <KeywordField onSubmit={onSubmit} placeholder={t<string>('Search.EngagementFilter')} />
      <CountriesField onSubmit={onSubmit} />
      <CampaignCategoryField
        title=""
        onSubmit={onSubmit}
        className="max-w-50"
        placeholder={t<string>('Selector.Campaign Category')}
      />
    </Form.Fields>
  );
};
